import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    visible: _ctx.isVisible,
    "mask-closable": false,
    "confirm-loading": _ctx.data.isLoading,
    title: "Create Gateway",
    onCancel: _ctx.emitCloseEvent,
    onOk: _ctx.fieldsValidation
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        model: _ctx.data,
        "label-col": { span: 8 },
        "wrapper-col": { span: 16 },
        autocomplete: "off",
        name: "form_in_modal",
        ref: "formRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            label: "Serial Number",
            name: "uniqueSerialNumber",
            rules: [{ required: true, message: 'Serial Number is required!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.data.uniqueSerialNumber,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.uniqueSerialNumber) = $event)),
                placeholder: "Serial Number",
                "allow-clear": true,
                disabled: _ctx.data.isLoading
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "Label",
            name: "label",
            rules: [{ required: true, message: 'Label is required!' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.data.label,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.label) = $event)),
                placeholder: "Label",
                "allow-clear": true,
                disabled: _ctx.data.isLoading
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            label: "IP Address",
            name: "address",
            rules: [
          { required: true, message: 'IP Address is required!' },
          { validator: _ctx.ipAddressValidation },
        ]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.data.address,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.address) = $event)),
                placeholder: "IP Address",
                "allow-clear": true,
                disabled: _ctx.data.isLoading
              }, null, 8, ["value", "disabled"])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading", "onCancel", "onOk"]))
}